import { Component, OnInit } from '@angular/core';

import { YouTubePlayerModule } from '@angular/youtube-player';
import { TranslateModule } from '@ngx-translate/core';
import { SeoService } from '../services/seo.service';

@Component({
  selector: 'app-video-instruction',
  imports: [YouTubePlayerModule, TranslateModule],
  standalone: true,
  templateUrl: './video-instruction.component.html',
  styleUrl: './video-instruction.component.scss'
})
export class VideoInstructionComponent implements OnInit {
  isDayMode = true;
  videoAC = 'https://youtu.be/53IV4Xc2Jxs';
  videoGP = 'https://youtu.be/nxp8AAMx7pY';
  maxWidth = 800;

  constructor(private seo: SeoService) {}

  getFrameVideo(videoUrl: string): string {
    if (!videoUrl) return '';

    const lastPart = videoUrl.substring(videoUrl.lastIndexOf('/') + 1);
    const cleanId = lastPart.split('?')[0];

    return cleanId;
  }

  initYoutube() {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.body.appendChild(tag);
  }

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Video návod - Asset Allocation Calculator',
      description:
        'Video návod k použití Asset Allocation Calculator. Naučte se analyzovat investiční portfolia, porovnávat fondy a modelovat investiční strategie.',
      keywords: 'video návod, asset allocation calculator, tutoriál, investiční nástroje, analýza portfolia',
      url: '/video-instruction'
    });

    this.initYoutube();
  }

  getWidth(): number {
    const containerWidth = document.body.offsetWidth;
    const padding = 40;
    const gap = 40;

    if (containerWidth < 768) {
      return Math.min(containerWidth - padding, 600);
    } else {
      return Math.min((containerWidth - gap - padding) / 2, 400);
    }
  }

  getHeight(): number {
    return this.getWidth() * (9 / 16);
  }
}
